import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../../app';

interface FeedbackState {
  rating: number;
  textareaValue: string;
  idleTime: boolean;
  drawerOpen: boolean;
}

const initialState: FeedbackState = {
  rating: 0,
  textareaValue: '',
  idleTime: false,
  drawerOpen: false,
};

const stateSlice = createSlice({
  name: 'feedback/state',
  initialState,
  reducers: {
    setRating: (state, action) => {
      state.rating = action.payload;
    },
    setTextareaValue: (state, action) => {
      state.textareaValue = action.payload;
    },
    setIdleTime: (state, action) => {
      state.idleTime = action.payload;
    },
    setFeedbackDrawerOpen: (state, action) => {
      state.drawerOpen = action.payload;
    },
  },
});

export const {
  setRating,
  setTextareaValue,
  setIdleTime,
  setFeedbackDrawerOpen,
} = stateSlice.actions;

export const feedbackState = (state: RootState) => state.feedback.state;

export default stateSlice.reducer;
